import { injectIntl } from "react-intl";
import React from "react";

function Tabs({ offices, activeItem, activeTabCb }) {
  const onTabClick = (name) => {
    activeTabCb(name)
  }
	return (
    <div className="tab-bar mb-m l:mb-l divider" data-rs-tab-bar="">
			{offices.map(([name]) => (
				<a href={`#?${name}`} key={name} className={`tab-bar__item ${activeItem == name ? "active" : ""}`} data-rs-tab-bar-item="" onClick={() => onTabClick(name)}>{name}</a>
			))}
		</div>
	);
}

export default injectIntl(Tabs);
